import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    IAccountMappingTemplateGroup,
    IAccountMappingTemplateGroupItemFLI,
} from '@modeso/types__aumico-lib-annualreport-be';
import { IGroupAccountMappingComponentDelegate } from '../../../interfaces/IGroupAccountMappingComponentDelegate.interface';
import { IUpdateAccount } from '../../../interfaces/update-account.interface';
import { generateAccountMappingComponentDelegate } from '../../../mappers/account-mapping-component-delegate';
import { AccountMappingEngine } from './../../../mappers/account-mapping-engin';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'templates-template-account-mapping-form',
    templateUrl: 'template-account-mapping-form.component.html',
    styleUrls: ['template-account-mapping-form.component.scss'],
})
export class TemplateAccountMappingComponent {
    showUncoveredShortFallButton = false;

    private _engine: AccountMappingEngine;
    @Input()
    public get engine(): AccountMappingEngine {
        return this._engine;
    }
    public set engine(value: AccountMappingEngine) {
        this._engine = value;

        this.prepareDelegates();
    }

    @Input()
    languages: string[] = ['de_ch', 'en_us'];

    @Input() defaultLanguage = 'de-ch';

    @Input()
    currency = '';

    @Input() cashAndCashFli: string | undefined;

    @Input() profitOfTheYearFliName: string | undefined;

    @Input() isCashFlowTypeForFliUsed: boolean | undefined;
    @Input() businessModel: string;
    @Input() reportLocale: string;

    @Input() type: string;
    @Input() hasPreviousData: boolean;

    @Input() disableEditingPreviousYearValue = false;

    @Input() supportOperation = false;

    @Input() errorInProfitFli: boolean | undefined;

    @Input() isAutomaticTransferOfAnnualResultEnabled: boolean | undefined;

    @Output() addOrUpdateAccountInActiveReport: EventEmitter<IUpdateAccount> = new EventEmitter<IUpdateAccount>();
    @Output() fliOrGroupDeleted: EventEmitter<IAccountMappingTemplateGroup | IAccountMappingTemplateGroupItemFLI> =
        new EventEmitter<IAccountMappingTemplateGroup | IAccountMappingTemplateGroupItemFLI>();

    isExpanded = false;
    touched = false;
    isCollapseButtonClicked: boolean | undefined;
    delegates: (IGroupAccountMappingComponentDelegate & { [key: string]: any })[]; // just to allow other properties

    expand() {
        this.isExpanded = true;
        this.touched = true;
        this.isCollapseButtonClicked = false;
        this.delegates.forEach((delegate) => {
            if (delegate) {
                delegate.collapseAll = false;
                delegate.expandAll = true;
            }
        });
    }

    collapse() {
        this.isExpanded = false;
        this.touched = true;
        this.isCollapseButtonClicked = true;
        this.delegates.forEach((delegate) => {
            if (delegate) {
                delegate.expandAll = false;
                delegate.collapseAll = true;
            }
        });
    }
    prepareDelegates() {
        if (this.engine) {
            const groups = this.engine.getTopGroups();
            this.delegates = [];
            // tslint:disable-next-line: prefer-for-of
            for (let groupIndex = 0; groupIndex < groups.length; groupIndex++) {
                const group = groups[groupIndex];
                let delegate: IGroupAccountMappingComponentDelegate = undefined;

                if (group != null) {
                    delegate = generateAccountMappingComponentDelegate(
                        () => this.engine,
                        () => this.engine && this.engine.draggedAccounts && this.engine.draggedAccounts.length > 0,
                        (mode) => {
                            /* no need for now */
                        },
                        () => (this.engine ? group : undefined),
                    );
                }
                this.delegates[groupIndex] = delegate;
            }
        } else {
            this.delegates = [];
        }
    }

    get dates(): {
        startDate: string | undefined;
        endDate: string | undefined;
    } {
        if (this.engine) {
            const dates = this.engine.getDates();
            return dates;
        }
        return {
            startDate: undefined,
            endDate: undefined,
        };
    }

    onAddOrUpdateActiveReport(updateAccountData: IUpdateAccount): void {
        this.addOrUpdateAccountInActiveReport.emit(updateAccountData);
    }

    public onFliOrGroupDeleted(deletedItem: IAccountMappingTemplateGroup | IAccountMappingTemplateGroupItemFLI): void {
        this.fliOrGroupDeleted.emit(deletedItem);
    }
}
